const BJsinglePage = [
  //  人脸识别
  {
    path: "/singlePage/accessControl/index",
    component: () => import("@/views/business/base/access-control"),
  },
  {
    path: "/singlePage/accessControl/access",
    component: () => import("@/views/business/base/access-control/access"),
  },
  {
    path: "/singlePage/accessControl/door",
    component: () => import("@/views/business/base/access-control/door"),
  },
  // 变配电

  {
    path: "/singlePage/distributionElectricity/index",
    component: () =>
      import("@/views/business/base/distributionElectricity/index"),
  },
  // 东府-高
  {
    path: "/singlePage/distributionElectricity/dongfu-high",
    component: () =>
      import("@/views/business/base/distributionElectricity/dongfuHigh"),
  },
  // 东府-低
  {
    path: "/singlePage/distributionElectricity/dongfu-low",
    component: () =>
      import("@/views/business/base/distributionElectricity/dongfuLow"),
  },
  // 西府-低
  {
    path: "/singlePage/distributionElectricity/xifu-low",
    component: () =>
      import("@/views/business/base/distributionElectricity/xifuLow"),
  },
  // 西府-高
  {
    path: "/singlePage/distributionElectricity/xifu-high",
    component: () =>
      import("@/views/business/base/distributionElectricity/xifuHigh"),
  },
  // 容郡-商业-高
  {
    path: "/singlePage/distributionElectricity/rongjun-high",
    component: () =>
      import("@/views/business/base/distributionElectricity/rongjunHigh"),
  },
  // 容郡-住宅-高
  {
    path: "/singlePage/distributionElectricity/rongjun-home-high",
    component: () =>
      import("@/views/business/base/distributionElectricity/rongjunHomeHigh"),
  },
  // 容郡-住宅-列表
  {
    path: "/singlePage/distributionElectricity/rongjun-home-list",
    component: () =>
      import("@/views/business/base/distributionElectricity/rongjunHomeList"),
  },
  // 容郡-列表
  {
    path: "/singlePage/distributionElectricity/rongjun-list",
    component: () =>
      import("@/views/business/base/distributionElectricity/rongjunList"),
  },
  // 容郡-低
  {
    path: "/singlePage/distributionElectricity/rongjun-low",
    component: () =>
      import("@/views/business/base/distributionElectricity/rongjunLow"),
  },
  // 东府配电室
  {
    path: "/singlePage/distributionElectricity/dongfu-high-list",
    component: () =>
      import("@/views/business/base/distributionElectricity/dongfuHighList"),
  },
  // 西府配电室
  {
    path: "/singlePage/distributionElectricity/xifu-high-list",
    component: () =>
      import("@/views/business/base/distributionElectricity/xifuHighList"),
  },
  // 东府照明
  {
    path: "/singlePage/illuminationSystem/index",
    component: () => import("@/views/business/qy/illuminationSystem/index"),
  },
  // 西府照明
  {
    path: "/singlePage/illuminationSystem/xifu",
    component: () => import("@/views/business/qy/illuminationSystem/xifu"),
  },
  // 消防
  {
    path: "/singlePage/fireFightingSystem/floor",
    component: () =>
      import("@/views/business/base/fireFightingSystem/index"),
  },

  //停车场
  {
    path: "/singlePage/parkingLotList/index",
    component: () => 
      import("@/views/business/base/parkingLotList/index"),
  },

  {
    path: "/singlePage/parkingLotList/first",
    component: () =>
      import("@/views/business/base/parkingLotList/first")
  }
];
export default BJsinglePage;
